<template>
  <div class="teams">
    <div class="top_row">
      <h2 class="title">团队信息</h2>
      <el-button
        class="btn"
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="onExport"
        >导出</el-button
      >
    </div>

    <el-button
      class="add_btn"
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="
        showAdd = true;
        getPostList();
      "
      >添加团队
    </el-button>

    <el-table
      class="team_list"
      :data="teamList"
      ref="dragTable"
      row-key="teamId"
      border
    >
      <el-table-column prop="icon" label="团队头像" width="120" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="scope.row.icon"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="团队名称" width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <i
            class="el-icon-edit"
            @click="
              currentTeam = { ...scope.row };
              showEdit = true;
            "
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="captainName"
        label="队长"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="score" label="成绩" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="审核状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 'RESOLVE'" style="color: #6ce115"
            >已通过</span
          >
          <span v-if="scope.row.status == 'PENDING'" style="color: #ffc55f"
            >审核中</span
          >
          <span v-if="scope.row.status == 'REJECT'" style="color: #f56c6c"
            >已拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column
        v-if="classInfo.douyin"
        prop="douyinAccessTokenExpireDate"
        label="抖音号状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.douyinAccessTokenExpireDate &&
              verDate(scope.row.douyinAccessTokenExpireDate)
            "
            style="color: #6ce115"
            >已授权</span
          >
          <span
            v-else-if="
              scope.row.douyinAccessTokenExpireDate &&
              !verDate(scope.row.douyinAccessTokenExpireDate)
            "
            style="color: #ffc55f"
            >授权已过期</span
          >
          <span v-else style="color: #f56c6c">未绑定</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="classInfo.douyin"
        prop="kuaishouRefreshTokenExpireDate"
        label="快手状态"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.kuaishouRefreshTokenExpireDate &&
              verDate(scope.row.kuaishouRefreshTokenExpireDate)
            "
            style="color: #6ce115"
            >已授权</span
          >
          <span
            v-else-if="
              scope.row.kuaishouRefreshTokenExpireDate &&
              !verDate(scope.row.kuaishouRefreshTokenExpireDate)
            "
            style="color: #ffc55f"
            >授权已过期</span
          >
          <span v-else style="color: #f56c6c">未绑定</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        :formatter="formatter"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 'RESOLVE'"
            @click.native.prevent="checkRow(scope.row)"
            type="text"
            size="small"
          >
            查看
          </el-button>
          <el-button
            v-if="scope.row.status == 'PENDING'"
            @click.native.prevent="editRow(scope.row, 'RESOLVE')"
            type="text"
            size="small"
          >
            审核
          </el-button>
          <el-button
            v-if="scope.row.status == 'PENDING'"
            @click.native.prevent="editRow(scope.row, 'REJECT')"
            type="text"
            size="small"
          >
            拒绝
          </el-button>
          <el-button
            @click.native.prevent="deleteRow(scope.row.teamId)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="新增团队"
      :visible.sync="showAdd"
      :before-close="handleClose"
      center
      width="60%"
    >
      <el-form
        :model="teamInfo"
        :rules="rules"
        ref="teamInfo"
        label-width="100px"
        class="add_form"
      >
        <el-form-item label="团队封面" prop="icon">
          <el-upload
            class="uploader"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="(file) => upload(file, 'icon')"
          >
            <el-image
              class="upload_img"
              v-if="teamInfo.icon"
              :src="teamInfo.icon"
              fit="cover"
            ></el-image>
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="团队名称" prop="name">
          <el-input
            v-model="teamInfo.name"
            placeholder="请输入团队名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="队长选择" prop="captainId">
          <el-select
            v-model="teamInfo.captainId"
            filterable
            placeholder="请选择队长"
          >
            <el-option
              v-for="item in studentList"
              :key="item.userId"
              :label="item.name + ' ' + item.sno"
              :value="item.userId"
              :disabled="item.teamName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="队长岗位" prop="postId">
          <el-select v-model="teamInfo.postId" placeholder="请选择岗位">
            <el-option
              v-for="item in postList"
              :key="item.postId"
              :label="item.name"
              :value="item.postId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('teamInfo')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <confirm-dialog :show="showConfirm" @onConfirm="onConfirm" />

    <el-dialog title="修改团队名称" :visible.sync="showEdit" width="30%" center>
      <el-input
        v-model="currentTeam.name"
        placeholder="请输入团队名称"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showEdit = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleEditTeam"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { postList } from "@/api/post";
import { teamList, editTeam, addTeam, delTeam, sortTeam } from "@/api/team";
import upload from "@/utils/uploadMethod";
import { formatDate } from "@/utils/index";
import confirmDialog from "@/components/confirmDialog/index.vue";
export default {
  components: {
    confirmDialog,
  },
  props: {
    classInfo: Object,
  },
  data() {
    return {
      postList: [],
      teamList: [],
      teamInfo: {
        icon: "",
        name: "",
        captainId: "",
        postId: "",
      },
      showAdd: false,
      rules: {
        icon: {
          required: true,
          message: "请上传团队封面",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "请输入团队名称",
          trigger: "blur",
        },
        captainId: {
          required: true,
          message: "请选择队长",
          trigger: "blur",
        },
        postId: {
          required: true,
          message: "请选择职务",
          trigger: "blur",
        },
      },
      showConfirm: false,
      teamId: null,
      showScort: false,
      currentId: null,
      teamSort: 1,
      showEdit: false,
      currentTeam: {},
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.setSort();
  },
  computed: {
    studentList() {
      return this.$store.state.studentList;
    },
  },
  methods: {
    setSort() {
      const el = this.$refs.dragTable.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      this.sortable = Sortable.create(el, {
        ghostClass: "sortable-ghost",
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        onEnd: (evt) => {
          const targetRow = this.teamList.splice(evt.oldIndex, 1)[0];
          this.teamList.splice(evt.newIndex, 0, targetRow);

          let teamIdList = [];
          this.teamList.forEach((item) => {
            teamIdList.push(item.teamId);
          });
          sortTeam(teamIdList).then(({ code, msg }) => {
            if (code == 0) {
              this.getList();
            } else {
              this.$message.error(msg);
            }
          });
        },
      });
    },
    //   团队列表
    getList() {
      this.$loading.show();
      teamList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          //   console.log(res);
          this.teamList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 岗位列表
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.teamInfo[str] = fileUrl;
    },
    // 导出
    onExport() {
      let token = localStorage.getItem("token");
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/team/export?classId=${this.$route.query.id}&Authorization=${token}`
      );
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 查看
    checkRow(team) {
      let that = this;
      this.$router.push({
        path: "/classCourse/teams/teamDetail",
        query: {
          ...that.$route.query,
          teamId: team.teamId,
          name: team.name,
        },
      });
    },
    // 审核
    editRow(team, status) {
      team.status = status;
      editTeam(team).then((res) => {
        if (res.code == 0) {
          if (status == "RESOLVE") this.$message.success("审核通过");
          if (status == "REJECT") this.$message.success("已拒绝");
          this.$store.commit("SET_UPDATE", true);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除
    deleteRow(teamId) {
      this.teamId = teamId;
      this.showConfirm = true;
    },
    onConfirm(val) {
      if (val) {
        delTeam(this.teamId).then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$message.success("删除成功");
            this.$store.dispatch("getStudents", {
              classId: this.$route.query.id,
            });
            this.$store.commit("SET_UPDATE", true);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      this.showConfirm = false;
    },
    // 创建团队
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addTeam({ ...this.teamInfo, classId: this.$route.query.id }).then(
            (res) => {
              if (res.code == 0) {
                this.handleClose();
                this.getList();
                this.$message.success("创建成功");
                this.$store.commit("SET_UPDATE", true);
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.teamInfo = this.$options.data().teamInfo;
      this.showAdd = false;
    },
    verDate(date) {
      let now = new Date().getTime();
      let checkDate = new Date(date).getTime();
      return checkDate - now > 0 ? true : false;
    },
    handleEditTeam() {
      editTeam(this.currentTeam).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.getList();
          this.showEdit = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.teams {
  padding: 20px 33px;
  background-color: rgb(255, 255, 255);

  .top_row {
    margin-bottom: 10px;
    line-height: 32px;
    overflow: hidden;

    .title {
      float: left;
    }

    .btn {
      float: right;
    }
  }

  .add_btn {
    width: 100%;
  }

  ::v-deep .team_list {
    margin-top: 20px;
    .is-leaf {
      color: #fff;
      background-color: teal;
    }
    .el-icon-edit {
      margin-left: 5px;
      color: teal;
      cursor: pointer;
    }
  }

  .add_form {
    .uploader {
      width: 160px;
      height: 160px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: teal;
      }

      .el-icon-plus {
        font-size: 28px;
        color: #8c939d;
        width: 160px;
        height: 160px;
        line-height: 160px;
        text-align: center;
      }

      .upload_img {
        width: 160px;
        height: 160px;
        display: block;
      }
    }

    .el-select {
      width: 100%;
    }
  }
}
</style>
